import { StatusChip } from './StatusChip'
import { cadastroStatus } from '../status'
import { useI18n } from '../../core/i18n/useI18n'

/** Pílula de status de cadastro (ativo/inativo/bloqueado/manutenção). */
export function CadastroStatusChip({ status }: { status: string | null | undefined }) {
  const { lang } = useI18n()
  void lang // o getter de `label` consulta o idioma atual
  const key = status ?? ''
  const m = cadastroStatus[key] ?? { label: key || '—', tone: 'neutral' as const }
  return <StatusChip label={m.label} tone={m.tone} />
}
